/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentCapabilitiesControllerEnvironmentsQueryResponse } from "../../models/incidentAgentController/IncidentCapabilitiesControllerEnvironments";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { incidentCapabilitiesControllerEnvironments } from "../../clients/incident-agentService/incidentCapabilitiesControllerEnvironments";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const incidentCapabilitiesControllerEnvironmentsQueryKey = () => [{
  url: '/api/v1/incident-agent/capabilities/environments'
}] as const;
export type IncidentCapabilitiesControllerEnvironmentsQueryKey = ReturnType<typeof incidentCapabilitiesControllerEnvironmentsQueryKey>;
export function incidentCapabilitiesControllerEnvironmentsQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = incidentCapabilitiesControllerEnvironmentsQueryKey();
  return queryOptions<IncidentCapabilitiesControllerEnvironmentsQueryResponse, ResponseErrorConfig<Error>, IncidentCapabilitiesControllerEnvironmentsQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return incidentCapabilitiesControllerEnvironments(config);
    }
  });
}

/**
 * {@link /api/v1/incident-agent/capabilities/environments}
 */
export function useIncidentCapabilitiesControllerEnvironments<TData = IncidentCapabilitiesControllerEnvironmentsQueryResponse, TQueryData = IncidentCapabilitiesControllerEnvironmentsQueryResponse, TQueryKey extends QueryKey = IncidentCapabilitiesControllerEnvironmentsQueryKey>(options: {
  query?: Partial<QueryObserverOptions<IncidentCapabilitiesControllerEnvironmentsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? incidentCapabilitiesControllerEnvironmentsQueryKey();
  const query = useQuery({
    ...incidentCapabilitiesControllerEnvironmentsQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}